import { createWebHistory, createRouter } from "vue-router";
const routes = [
  {
    path: "/",
    name: "main",
    component: () => import("@/views/ChatMain.vue"),
  },
];

const router = createRouter({
  base: process.env.BASE_URL,
  history: createWebHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
//   next();
// });

export default router;
